import {translate} from "@prosay/i18n"
import React from "react"
import {StyleSheet} from "react-native"
import {Searchbar as PaperSearchBar} from "react-native-paper"

const styles = StyleSheet.create({
    searchbarStyle: {
        backgroundColor: "rgb(52, 160, 255)",
        borderRadius: 0,
    },
    searchbarinputStyle: {
        color: "#ffffff",
    },
})

export interface SearchBarProps {
    placeholder?: string
    search: string
    setSearch: (value: string) => void
}
export const SearchBar: React.FC<SearchBarProps> = ({
    search,
    setSearch,
    placeholder = translate("ui.screen.conversations.searchBarPlaceholder"),
}) => (
    <PaperSearchBar
        placeholder={placeholder}
        onChangeText={setSearch}
        value={search}
        style={styles.searchbarStyle}
        inputStyle={styles.searchbarinputStyle}
        placeholderTextColor="#ffffff"
        iconColor="#ffffff"
    />
)
